import React from 'react';
import {Table as BaseTable} from 'desktop/sports/mlb/players-list/single-game';

class Table extends BaseTable {}

export {Table};
